export default "__VITE_ASSET__a4onhpW9__"